<template>
	<div class="d-flex flex-1">
		<v-card class="report-container w-100  p-0" style="border-radius: 12px; margin-bottom: 24px">
			<v-toolbar class="shadow-none" style="flex: unset;" content-class="h-auto">
                <div class="custom-icon-wrapper">
                    <v-icon @click="backToAdminPage()">custom-icon left-arrow-icon</v-icon>
                </div>
                <v-toolbar-title class="size-16 dark-text">{{ $t("res_Label_ManageActions") }}</v-toolbar-title>
            </v-toolbar>
            <div>
				<v-card-title>
					<div class="border-top flex-1 overflow-auto d-flex align-center gap-2" style="padding-top: 5px;">
						<v-text-field v-model="search" :placeholder="$t('res_Label_SearchPlaceHolder')"
							prepend-inner-icon="mdi-magnify" solo dense hide-details clearable
							style="max-width: 320px;"></v-text-field>
						<v-spacer></v-spacer>
						<v-btn v-if="roleId == 1" @click="showAddDialog" width="200px" color="primary">{{ $t("res_Label_AddAction") }}</v-btn>
					</div>
				</v-card-title>
			</div>
			<div class="d-flex flex-1 flex-column overflow-auto" style="padding: 5px">
				<v-data-table :headers="visibleHeaders()" :items="filteredItems()" :items-per-page="-1" disable-sort hide-default-footer class="elevation-1">
					<template v-slot:item="row">
						<tr>
							<td>{{row.item.name}}</td>
							<td>{{showtext(row.item.type)}}</td>
							<td>{{showApplicationText(row.item.applicationId)}}</td>
							<td>{{row.item.order}}</td>
                            <td>{{row.item.icon}}</td>
                            <td>{{row.item.tooltip}}</td>
							<td v-if="roleId == 1" class="text-start">
								<div class="onhover-display">
									<div class="custom-icon-wrapper">
										<v-icon small @click="editItem(row.item)">custom-icon white-bg edit-icon</v-icon>
									</div>
									<div class="custom-icon-wrapper">
										<v-icon small @click="openDeleteDialog(row.item)">custom-icon white-bg delete-icon</v-icon>
									</div>
								</div>
							</td>
						</tr>
					</template>
				</v-data-table>
			</div>
		</v-card>
		<v-dialog v-model="addDialogVisible" max-width="500px" >
			<v-card>
                <v-toolbar class="bg-white">
                    <v-card-title class="p-0">
						<span v-if="editedItem.id">{{ $t("res_Label_EditAction") }}</span>
                        <span v-else>{{ $t("res_Label_AddAction") }}</span></v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn class="close-btn light-btn" icon dark @click="addDialogVisible = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <div class="d-flex flex-column overflow-auto h-100">
                   <div class="grid-12 flex-1 p-4 overflow-auto gap-2">
						<v-row>
							<v-col cols="12">
								<v-label>{{ $t("res_Label_Name") }} *</v-label>
                                <v-text-field solo v-model="editedItem.name" ></v-text-field>
							</v-col>
							<v-col cols="6" sm="6">
								<v-label>{{ $t("res_Label_Type") }} *</v-label>
                                <v-select v-model="editedItem.type" :items="selectValue" solo ></v-select>
							</v-col>
							<v-col cols="6" sm="6">
								<v-label>{{ $t("res_Label_Applications") }} *</v-label>
                                <v-select v-model="editedItem.applicationId" :items="applications" item-text="name" item-value="id" solo ></v-select>
							</v-col>
							<v-col cols="6" sm="6">
								<v-label>{{ $t("res_Label_Order") }}</v-label>
								<v-text-field solo v-model="editedItem.order" type="number"></v-text-field>
							</v-col>
							<v-col cols="6" sm="6">
                                <v-label>{{ $t("res_Label_Icon") }}</v-label>
								<v-text-field solo v-model="editedItem.icon"></v-text-field>
							</v-col>
                            <v-col cols="6" sm="6">
                                <v-label>{{ $t("res_Label_Tooltip") }}</v-label>
								<v-text-field solo v-model="editedItem.tooltip"></v-text-field>
							</v-col>
						</v-row>
					</div>
					<v-card-actions class="gap-2 sticky-actions">
						<v-spacer></v-spacer>
						<v-btn class="light-blue" style="min-width: 100px !important;" @click="cancelAddDialog()">{{ $t("res_ButtonText_Cancel") }}</v-btn>
						<v-btn class="primary" style="min-width: 100px !important;" @click="upsertItem(editedItem)">{{ $t("res_ButtonText_Continue") }}</v-btn>
					</v-card-actions>
				</div>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import axios from "axios"
import constants from "@/assets/js/constants.js"
import router from '@/router/index.js'
import ActionSecurityRole from '@/components/ActionSecurityRole.vue'

export default {
    components: { ActionSecurityRole },
	data() {
		return {
			headers: [
				{ text: this.$t("res_GridHeaders_Name"),    value: "name",      align: "start",   width: "20%"   },
				{ text: this.$t("res_GridHeaders_Type"),    value: "type",      align: "start",   width: "10%"   },
				{ text: this.$t("res_GridHeaders_Application"),    value: "applicationId",      align: "start",   width: "10%"   },
				{ text: this.$t("res_GridHeaders_Order"),   value: "order",     align: "start",   width: "10%"   },
                { text: this.$t("res_GridHeaders_Icon"),    value: "icon",      align: "start",   width: "20%"   },
                { text: this.$t("res_GridHeaders_Tooltip"), value: "tooltip",   align: "start",   width: "20%"   },
				{ text: this.$t("res_GridHeaders_Actions"), value: "actions",   align: "start",   width: "10%"   },
			],
			items: [],
			search: "",
			roleId: JSON.parse(sessionStorage.getItem("user")).profile.ApplicationRoleId,
            selectValue: [
				{ text: 'Menu', value: 1 }, 
				{ text: 'Toolbar Menu', value: 2 }, 
				{ text: 'Feature', value: 3},
				{ text: 'Reports', value: 4 } 
            ],
			applications:[],
            types: { 1: 'Menu', 2: 'Toolbar Menu', 3: 'Feature', 4: 'Reports'},
			addDialogVisible: false,
			editedItem: {
                id: 0,
			    name: "",
				type: null,
				order: null,
				icon: "",
				tooltip: "",
				applicationId: 0
			},
			editedRoleId: 0,
		};
	},
	methods: {
		visibleHeaders()
		{
			return this.roleId == 1 ? this.headers : this.headers.filter(h => h.value != "actions")
		},
		filteredItems()
		{
			const term = (this.search || "").trim().toLowerCase()
			if (term == "") return this.items

			return this.items.filter(item =>
				[item.name, this.showtext(item.type), this.showApplicationText(item.applicationId),
				 item.order, item.icon, item.tooltip]
					.some(value => value != null && String(value).toLowerCase().includes(term)))
		},
		backToAdminPage()
		{
            router.push({ name: 'admin' })
        },
        showtext(value){
            return this.types[value] || ""
        },
		showApplicationText(value)
		{
			const application = (this.applications || []).find(app => app.id == value);
			return application ? application.name : "";
		},
		async fetchData() 
		{
			this.applications = window.applications || []

			window.showLoading()
			const res = await axios
				.get(constants.baseApiUrl + "ActionSecurity/GetActions")
				.then((res) => 
				{
					this.items = res.data;
				})
				.catch((error) => console.error("Error fetching data:", error))
				.finally(() => window.hideLoading());
		},
		showAddDialog() 
		{
			this.addDialogVisible = true
			this.editedItem = {id:0, name:"", type:null, order: null, icon:"", tooltip:"", applicationId: null }
		},
		editItem(item) 
		{
			this.editedItem = item
			this.addDialogVisible = true
		},
		async upsertItem(item)
		{
            if (this.editedItem.name.trim() == "" || this.editedItem.type == null || this.editedItem.applicationId == null)
			{
				window.showAlert('res_Msgs_FillRequired', 'warning')
				return
			}
			else if(this.editedItem.order != null && this.editItem.order != "")
			{
				const order = parseInt(this.editedItem.order)
				const containsDecimal = String(this.editedItem.order).includes('.');
				if (isNaN(order) || containsDecimal || order < 0) {
					window.showAlert(this.$t("res_Msgs_EnterAPositiveNumber").replace('{0}',  'Order number'), 'warning');
					return
				}
			}
			if (this.editedItem.id == 0)
			{
				var Actionobj = {id:0, name:this.editedItem.name, type:this.editedItem.type, order:this.editedItem.order,
                icon:this.editedItem.icon,tooltip:this.editedItem.tooltip, applicationId: this.editedItem.applicationId}

				await axios.post(constants.baseApiUrl + "ActionSecurity/AddNewAction",Actionobj)
					.then((res) => this.cancelAddDialog())
					.catch((err) => console.error("Error creating item:", err));
			}
			else
			{
				var Actionobj = {id:this.editedItem.id, name:this.editedItem.name, type:this.editedItem.type, order:this.editedItem.order,
                icon:this.editedItem.icon,tooltip:this.editedItem.tooltip, applicationId: this.editedItem.applicationId }

				await axios.post(constants.baseApiUrl + "ActionSecurity/UpdateAction?id="+item.id, Actionobj)
					.then((res) => this.cancelAddDialog())
					.catch((err) => console.error("Error Updating item:", err));
			}
		},
		cancelAddDialog() 
		{
			this.addDialogVisible = false
            this.editedItem.id = null
            this.editedItem.name = ""
            this.editedItem.type = null
            this.editedItem.order = null
            this.editedItem.icon = ""
            this.editedItem.tooltip = ""
			this.editedItem.applicationId = null
			this.fetchData()
		},
		openDeleteDialog(item) 
		{
            window.showInformation(this.$t('res_Label_Alert'), this.$t("res_Msgs_DeletConfirmation"),
                () => 
				{
					axios.get(constants.baseApiUrl + "ActionSecurity/DeleteAction?id=" + item.id)
						.then((res) => this.fetchData())
						.catch((err) => console.log(err));
                },
                () => { })
		},
	},
    mounted() 
	{
		this.fetchData()
	},
};
</script>